import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { CryptoTopUpStepUi } from "@src/widgets/onboarding/ui/tours/AccountTopUp/CryptoTopUpStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class CryptoTopUpStep extends TourStepBase {
  component = CryptoTopUpStepUi
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_BalancesCryptoTopUp`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_DEPOSIT_QR"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT,
    })
  }

  action() {
    return router.navigate({
      pathname: generatePath(paths.deposit, { network: "tron", symbol: "TRX" }),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Ensure your crypto balances are sufficient",
      title: "Crypto Balance Top-Up",
    }
  }
}
